import Banner from "components/common/Banner";
import CorporativeCultureOverlay from "components/CorporativeCultureSection/CorporativeCultureOverlay/CorporativeCultureOverlay";
import CorporativeCultureOverlayMobile from "components/CorporativeCultureSection/CorporativeCultureOverlay/CorporativeCultureOverlayMobile";

import envs from "config/envs";

const BannerCorporativeCulture = () => {
  return (
    <section role="banner">
      <Banner
        background={`${envs.HOST_STATIC_CDN}/AreaAberta/Images/banner_cultura_corporativa.webp`}
        width="100vw"
        height="45vw"
      >
        <Banner.Overlay center={false}>
          <CorporativeCultureOverlay />
        </Banner.Overlay>
      </Banner>

      <Banner
        mobileBackground={`${envs.HOST_STATIC_CDN}/AreaAberta/Images/banner_cultura_corporativa_mobile.webp`}
        width="100vw"
        height="130vw"
        isMobile
      >
        <Banner.Overlay center={false} isMobile>
          <CorporativeCultureOverlayMobile />
        </Banner.Overlay>
      </Banner>
    </section>
  );
};

export default BannerCorporativeCulture;
